import {resi18nutil} from "language/resi18nutil";
import {resi18n_all_en, resi18n_all_enus, resi18n_all_ko} from "language/resi18n_all";

const resi18n_qr_manual = {
  I18N_QR_MANUAL_WIRING: ["배선도", "Wiring", undefined],

  I18N_QR_MANUAL_PARAMETER: ["파라미터", "Parameter", undefined],
  I18N_QR_MANUAL_KEYPAD_COMPOSITION: ["키패드 화면 구성", "Keypad Composition", undefined],
  I18N_QR_MANUAL_PARAMETER_GROUP_COMPOSITION: ["파라미터 메뉴 구성", "Parameter Group Composition", undefined],
  I18N_QR_MANUAL_PARAMETER_SETTING: ["주요 파라미터 설정", "Parameter Setting", undefined],
  I18N_QR_MANUAL_KEYPAD_SIMULATION: ["키패드 작동방법", "Keypad Simulation", undefined],

  I18N_QR_MANUAL_SPECIFICATIONS: ["제품 규격", "Specifications", undefined],

  I18N_QR_MANUAL_OPTION_LIST: ["옵션리스트", "Option List", undefined],
  I18N_QR_MANUAL_OPERATION_MANUAL: ["제품 매뉴얼", "Operation Manual", undefined],
  I18N_QR_MANUAL_MANUAL_DOWNLOAD: ["매뉴얼 다운로드", "Manual Download", undefined],
  I18N_QR_MANUAL_QUICK_GUIDE: ["퀵 가이드", "Quick Guide", "Quick Guide"],

  I18N_QR_MANUAL_TROUBLESHOOTING: ["트러블슈팅", "Troubleshooting", undefined],
  I18N_QR_MANUAL_FAULT_TRIPS_OCCURS: ["이상 발생 시 조치사항", "Fault trips occurs", undefined],
  I18N_QR_MANUAL_AFTER_A_TEST_RUN: ["설치 시 점검사항", "After a test run", undefined],
  I18N_QR_MANUAL_MAINTENANCE: ["유지 보수 점검 활동", "Maintenance", undefined],
  I18N_QR_MANUAL_FAULT_TRIPS: ["트립 시 조치사항", "Fault Trips", undefined],
  I18N_QR_MANUAL_OTHER_FAULTS: ["기타 문제 발생시 조치사항", "Other Faults", undefined],
  I18N_QR_MANUAL_TRIP: ["트립", "Trip", undefined],
  I18N_QR_MANUAL_TRIPS_AND_WARNING: ["고장/경보 일람표", "Trips and Warning", undefined],

  I18N_CUSTOMER_SERVICE: ["고객 센터", "Customer Service", "Customer Service"],
  I18N_TOTAL_MANUAL: ["전체 매뉴얼", undefined, undefined],
  I18N_DOWNLOAD: ["다운로드", undefined, undefined],
  I18N_CALL_CUSTOMER_SERVICE: ["고객 센터", "Customer Service", "Customer Service"],
  I18N_SSQ_HOME: ["솔루션 스퀘어", "Solution Square", "Solution Square"],
  I18N_CONTACT_US: ["고객 센터", "Contact Us", "Contact Us"],
  I18N_QUICK_GUIDE: [undefined, "Quick Guide", "Quick Guide"],
  I18N_REGISTRATIION: [undefined, "Registration", "Registration"],

  I18N_SHOW_CATEGORY: ["카테고리 펼치기", "Show categories", undefined],
  I18N_CLOSE_CATEGORY: ["카테고리 접기", "Hide categories", undefined],
  I18N_DOC_COL_NAME: ["자료명", "Name", undefined],
  I18N_DOC_VIEW_MORE: ["더보기", "View More", undefined],
  I18N_TITLE_QR_HOME: ["QR", "QR", undefined],
  I18N_TITLE_QR_MANUAL: ["QR 매뉴얼", "QR Manual", "QR Manual"],
  I18N_TITLE_PRODUCT: ["제품", "Product", undefined],
  I18N_NO_DOCUMENT: ["조회된 자료가 없습니다.", "No result found.", undefined],
  I18N_NO_DOCUMENT_NOTICE: ["조회 필터를 설정해 주세요.", "Choose different filters.", undefined],
  I18N_NO_DOCUMENT_RESET: ["필터 초기화", "Reset filters", undefined],
  I18N_DOC_HOMEPAGE_BUTTON: ["상세 정보 보기", "More Details", undefined],
  I18N_CATEGORY_PREVIEW_MODEL: ["모델", "Model", undefined],

  I18N_CUSTOMER_SERVICE_US: [undefined, "US", "US"],
  I18N_CUSTOMER_SERVICE_US_EMAIL: [undefined, "sales.us@lselectricamerica.com", "sales.us@lselectricamerica.com"],
  I18N_CUSTOMER_SERVICE_US_TEL: [undefined, "+1 800-891 2941", "+1 800 891 2941"],
  I18N_CUSTOMER_SERVICE_EUROPE: [undefined, "Europe", "Europe"],
  I18N_CUSTOMER_SERVICE_EUROPE_EMAIL: [undefined, "europartner@ls-electric.com", "europartner@ls-electric.com"],
  I18N_CUSTOMER_SERVICE_EUROPE_TEL: [undefined, "+31 20 654 1420", "+31 20 654 1420"],
  I18N_CUSTOMER_SERVICE_ITALY: [undefined, "Italy", "Italy"],
  I18N_CUSTOMER_SERVICE_ITALY_EMAIL: [undefined, "paolouggeri@ls-electric.com", "paolouggeri@ls-electric.com"],
  I18N_CUSTOMER_SERVICE_ITALY_TEL: [undefined, "+39 347 478 8209", "+39 347 478 8209"],
};


const [ko, en, enus] = resi18nutil.getres(resi18n_qr_manual);

export const resi18n_qr_manual_ko = {...resi18n_all_ko, ...ko};
export const resi18n_qr_manual_en = {...resi18n_all_en, ...en};
export const resi18n_qr_manual_enus = {...resi18n_all_enus, ...enus};